import React, { Component } from 'react';
import __ from 'lodash';
import parse from 'html-react-parser';

class TblSvKarakterSekolah extends Component {
    constructor(props) {
        super(props);
        this.state = {             
            dataSekolah: [],
            aspek: "",
            tipe: ''
        }
    }

    componentDidMount() {
        if(!__.isEmpty(this.props.data)) {                         
            this.setState({ dataSekolah: this.props.data , aspek: this.props.aspek, tipe: this.props.tipe})
        }
    }

    renderRow(data) {
        let hasil = 'Cukup';
        if(data.cukup < data.baik) hasil = 'Baik';
        if(data.baik < data.sangatBaik) hasil = this.state.tipe === 'SK' ? 'Unggul' : 'Sangat Baik';

        return(
            <>
                <td className="text-center">{data.sangatBaik}</td><td className="text-center">{data.pSangatBaik}</td>
                <td className="text-center">{data.baik}</td><td className="text-center">{data.pBaik}</td>
                <td className="text-center">{data.cukup}</td><td className="text-center">{data.pCukup}</td>
                <td className="text-center">{hasil}</td>
            </>
        )        
    }

    render() {
        return(
            <table className="table-asm" width="100%" border="1">
                <thead>
                    <tr>
                        <th className="text-center" rowSpan="3" style={{width: '5px'}}>No</th>
                        <th className="text-center" rowSpan="3" style={{maxWidth: '30%'}}>Nama Sekolah</th>  
                        <th className="text-center" rowSpan="3" style={{width: '10px'}}>Jumlah Siswa</th>
                        <th className="text-center" colSpan="7">{this.state.aspek}</th>
                    </tr>
                    <tr>   
                        
                        <th className="text-center" colSpan="2" style={{width: '10px'}}>{this.state.tipe === 'SK' ? 'Unggul' : 'Sangat Baik'}</th>
                        <th className="text-center" colSpan="2" style={{width: '10px'}}>Baik</th>
                        <th className="text-center" colSpan="2" style={{width: '10px'}}>Cukup</th>
                        <th className="text-center" rowSpan="2" style={{width: '10px'}}>Kesimpulan</th>
                    </tr> 
                    <tr>
                        <th className="text-center">Jumsis</th><th className="text-center">%</th>
                        <th className="text-center">Jumsis</th><th className="text-center">%</th>
                        <th className="text-center">Jumsis</th><th className="text-center">%</th>
                    </tr>
                </thead>
                <tbody>
                    {this.state.dataSekolah.map((value, i) => 
                    <tr key={i}>
                        <td className="text-center">{i+1}</td>
                        <td>{value.namaSekolah}</td>
                        <td className="text-center">{value.jumsis}</td>
                        {this.state.tipe.toUpperCase() === 'SK' ?
                            this.renderRow(value.SK.find(d => d.aspek === this.state.aspek)) :
                            this.renderRow(value.SLB.find(d => d.aspek === this.state.aspek))
                        }
                    </tr>
                    )}
                </tbody>
            </table>
        )
    }
}

export default TblSvKarakterSekolah;